export * from './lib/products.module';
export * from './lib/services/categories.service';
export * from './lib/services/products.service';
export * from './lib/models/category';
export * from './lib/models/product';
